import { renderLogo } from "./Topbar";




export const Logo = ({ activePage = '', firstPage = '', onClick = () => void (0) }) => {
  
  return (
    <div className={`x_logo_text page--${activePage} ${firstPage}`}
    onClick={() => {
      onClick()
    }}
  >
    HD
    <div style={{
      height: '0.8em',
      width: '0.2em',
      borderBottom: '0.2em solid var(--accent)',
      margin: '0 0.1em',
    }}></div>
    {/* <div className="hd_logo_img w-embed">
      {renderLogo()}
    </div> */}
    Cafe
  </div>
  );
};